import { render, staticRenderFns } from "./CardCompany.vue?vue&type=template&id=b9c2e29e&"
import script from "./CardCompany.vue?vue&type=script&lang=js&"
export * from "./CardCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports